import { combineReducers } from "redux";
import * as types from "../constants/ActionTypes";

const initialState = {
  data: {},
  ui: {
    fetching: false,
    error: null
  }
};

const ui = (s = initialState.ui, a) => {
  switch (a.type) {
    case types.CART_ITEMS_WILL_REFRESH:
    case types.CART_ITEMS_TOTAL_QUANTITY_WILL_REFRESH:
      return { ...s, fetching: true, error: null };
    case types.CART_ITEMS_DID_REFRESH_FAILED:
    case types.CART_ITEMS_TOTAL_QUANTITY_DID_REFRESH_FAILED:
      return { ...s, fetching: false, error: a.error };
    case types.CART_ITEMS_DID_REFRESH:
    case types.CART_ITEMS_TOTAL_QUANTITY_DID_REFRESH:
      return { ...s, fetching: false, error: null };
    default:
      return s;
  }
};

const data = (s = initialState.data, a) => {
  switch (a.type) {
    case types.CART_ITEMS_DID_REFRESH:
    case types.CART_ITEMS_TOTAL_QUANTITY_DID_REFRESH:
      return { ...a.data };
    case types.CART_ITEMS_DID_REFRESH_FAILED:
      return { order_items: [] };
    default:
      return s;
  }
};

export default combineReducers({ ui, data });

export { initialState };
